import Loader from '@components/Loader';
import Group from '../Group/Group.vue';

export default {
  name: 'Inner',
  components: {
    Group,
    Loader,
  },
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    documentSlug: {
      type: String,
      default: '',
    },
    contextSlug: {
      type: String,
      default: '',
    },
  },
};
